import React from 'react'
import * as R from 'ramda'
import Button from '@components/button'
import { Choose, If, Otherwise, When } from 'tsx-control-statements/components'
import withTranslate from 'redux-polyglot/translate'
import { getLargestButtonSize } from 'domain/button'
import { ErrorMessageWrapper as Wrapper } from '../style'
import withConnect from './connector'
import { Props } from './types'

const Technical: React.FC<Props> = ({
  homePageURL,
  onPreviousPage,
  onReloadApp,
  p,
  partner,
  resourceType,
  screenSize
}) => (
  <Wrapper
    partner={partner}
  >
    <div className='Error__InformationBlock'>
      <h1 className='Error__Title'>
        {p.tc('sorry')}
      </h1>
      <h2 className='Error__SubTitle'>
        {`${p.tc('technical_error_happened') as string}.`}
      </h2>

      <Choose>
        <When condition={R.equals('product', resourceType)}>
          <p className='Error__Sentence'>
            {p.tc('cant_display_offer')}
          </p>
          <div className='Error__WrapperButton'>
            <Button
              shouldFitToContainer
              label={p.tc('return_previous_page')}
              onClick={onPreviousPage}
              size={getLargestButtonSize(screenSize)}
              variant='primary'
            />
          </div>
        </When>
        <Otherwise>
          <p className='Error__Sentence'>
            {p.tc('cant_display_sale')}
          </p>
          <div className='Error__WrapperButton'>
            <Button
              shouldFitToContainer
              label={p.tc('reload_page')}
              onClick={onReloadApp}
              size={getLargestButtonSize(screenSize)}
              variant='primary'
            />
          </div>
        </Otherwise>
      </Choose>

      <If condition={homePageURL}>
        <a className='Error__WrapperButton' href={homePageURL}>
          <Button
            shouldFitToContainer
            label={p.tc('return_home')}
            size={getLargestButtonSize(screenSize)}
            variant='secondary'
          />
        </a>
      </If>
    </div>
    <div className='Error__Image' />
  </Wrapper>
)

export default R.compose(
  withConnect,
  withTranslate('errors')
)(Technical)
